var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-project-icon d-inline-flex flex-column",class:{ 'large': _vm.large }},[_c('AxIcon',{class:_vm.iconClasses,attrs:{"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }